/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { ApprovePaymentProviderInvitationApprovalRequestRequest } from '../models/ApprovePaymentProviderInvitationApprovalRequestRequest';
import type { GetPaymentProviderApprovalRequestResponse } from '../models/GetPaymentProviderApprovalRequestResponse';
import type { ListPaymentProviderApprovalRequestsResponse } from '../models/ListPaymentProviderApprovalRequestsResponse';
import type { RegisterPaymentProviderInvitationApprovalRequestIssueRequest } from '../models/RegisterPaymentProviderInvitationApprovalRequestIssueRequest';
import type { RegisterPaymentProviderInvitationApprovalRequestIssueResponse } from '../models/RegisterPaymentProviderInvitationApprovalRequestIssueResponse';
import type { ResolvePaymentProviderInvitationApprovalRequestIssueRequest } from '../models/ResolvePaymentProviderInvitationApprovalRequestIssueRequest';
import type { ResolvePaymentProviderInvitationApprovalRequestIssueResponse } from '../models/ResolvePaymentProviderInvitationApprovalRequestIssueResponse';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class PaymentProviderInvitationApprovalRequestControllerv2Service {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns ListPaymentProviderApprovalRequestsResponse
     * @throws ApiError
     */
    public paymentProviderInvitationApprovalRequestControllerv2ListPaymentProviderApprovalRequests(): Observable<ListPaymentProviderApprovalRequestsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/payment-provider-approvalrequest',
        });
    }
    /**
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public paymentProviderInvitationApprovalRequestControllerv2SendApprovalRequest(
        requestBody: number,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/payment-provider-approvalrequest',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns GetPaymentProviderApprovalRequestResponse
     * @throws ApiError
     */
    public paymentProviderInvitationApprovalRequestControllerv2GetPaymentProviderApprovalRequest(
        id: number,
    ): Observable<GetPaymentProviderApprovalRequestResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/payment-provider-approvalrequest/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public paymentProviderInvitationApprovalRequestControllerv2ApproveApprovalRequest(
        id: number,
        requestBody: ApprovePaymentProviderInvitationApprovalRequestRequest,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/payment-provider-approvalrequest/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param patientId
     * @returns boolean
     * @throws ApiError
     */
    public paymentProviderInvitationApprovalRequestControllerv2HasAlreadyAccountInPq(
        patientId: number,
    ): Observable<boolean> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/payment-provider-approvalrequest/{patientId}/has-already-account-in-pq',
            path: {
                'patientId': patientId,
            },
        });
    }
    /**
     * @param paymentProviderInvitationApprovalRequestId
     * @param requestBody
     * @returns RegisterPaymentProviderInvitationApprovalRequestIssueResponse
     * @throws ApiError
     */
    public paymentProviderInvitationApprovalRequestControllerv2RegisterPaymentProviderInvitationApprovalRequestIssue(
        paymentProviderInvitationApprovalRequestId: number,
        requestBody: RegisterPaymentProviderInvitationApprovalRequestIssueRequest,
    ): Observable<RegisterPaymentProviderInvitationApprovalRequestIssueResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/payment-provider-approvalrequest/{PaymentProviderInvitationApprovalRequestId}/issue',
            path: {
                'PaymentProviderInvitationApprovalRequestId': paymentProviderInvitationApprovalRequestId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param paymentProviderInvitationApprovalRequestId
     * @param issueId
     * @param requestBody
     * @returns ResolvePaymentProviderInvitationApprovalRequestIssueResponse
     * @throws ApiError
     */
    public paymentProviderInvitationApprovalRequestControllerv2ResolvePaymentProviderInvitationApprovalRequestIssue(
        paymentProviderInvitationApprovalRequestId: number,
        issueId: number,
        requestBody: ResolvePaymentProviderInvitationApprovalRequestIssueRequest,
    ): Observable<ResolvePaymentProviderInvitationApprovalRequestIssueResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/payment-provider-approvalrequest/{PaymentProviderInvitationApprovalRequestId}/issue/{issueId}',
            path: {
                'PaymentProviderInvitationApprovalRequestId': paymentProviderInvitationApprovalRequestId,
                'issueId': issueId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
